import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52cd823e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TransferOfMoney" }
const _hoisted_2 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_3 = { class: "ant-upload-drag-icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"10px"} }, "点击或拖拽上传", -1))
const _hoisted_5 = {
  key: 0,
  class: "piliangyulan_box"
}
const _hoisted_6 = { class: "piliangyulan_box_title" }
const _hoisted_7 = { class: "piliangyulan_box_table" }
const _hoisted_8 = {
  key: 1,
  class: "clearfix"
}
const _hoisted_9 = { class: "ant-upload-drag-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"10px"} }, "点击或拖拽上传", -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "rolemanagement_box"
}
const _hoisted_13 = { style: {"width":"100%","display":"flex","justify-content":"space-around"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_inbox_outlined = _resolveComponent("inbox-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      activeKey: $setup.activeKey,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => (($setup.activeKey) = $event)),
      type: "card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "单笔转账"
        }),
        _createVNode(_component_a_tab_pane, {
          key: "4",
          tab: "批量制单",
          disabled: $setup.user.roule !== 0 && $setup.user.roule !== 1
        }, null, 8, ["disabled"]),
        _createVNode(_component_a_tab_pane, {
          key: "2",
          tab: "打款列表"
        })
      ]),
      _: 1
    }, 8, ["activeKey"]),
    ($setup.activeKey === '4')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_upload_dragger, {
            "file-list": $setup.fileList,
            "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => (($setup.fileList) = $event)),
            "list-type": "picture",
            "before-upload": $setup.beforeUpload,
            onChange: $setup.uploadDraggerChange,
            onRemove: $setup.handleRemove,
            "max-count": 1
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, [
                _createVNode(_component_inbox_outlined)
              ]),
              _hoisted_4,
              _createVNode(_component_a_button, {
                style: {"margin":"20px 0"},
                type: "primary",
                onClick: _withModifiers($setup.DownloadTemplateZD, ["stop"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载批量制单模板")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["file-list", "before-upload", "onChange", "onRemove"]),
          _createVNode(_component_a_button, {
            type: "primary",
            disabled: $setup.fileList.length === 0,
            loading: $setup.uploading,
            style: {"margin-top":"16px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.handleUpload(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.uploading ? '正在加载' : '确认制单'), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          ($setup.jsonData.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.jsonDataTitle[0], (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "piliangyulan_box_title_item"
                    }, _toDisplayString(item), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.jsonData, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "piliangyulan_box_table_row",
                      style: _normalizeStyle(index === 0 ? 'border-top:none;' : ''),
                      key: index
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (items, indexs) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "piliangyulan_box_table_row_item",
                          key: indexs
                        }, [
                          _createElementVNode("div", null, _toDisplayString(items), 1)
                        ]))
                      }), 128))
                    ], 4))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.activeKey === '3')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_a_upload_dragger, {
            "file-list": $setup.fileList,
            "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => (($setup.fileList) = $event)),
            "list-type": "picture",
            "before-upload": $setup.beforeUpload,
            onRemove: $setup.handleRemove,
            "max-count": 1
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_9, [
                _createVNode(_component_inbox_outlined)
              ]),
              _hoisted_10,
              _createVNode(_component_a_button, {
                style: {"margin":"20px 0"},
                type: "primary",
                onClick: _withModifiers($setup.DownloadTemplate, ["stop"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载批量支付模板")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["file-list", "before-upload", "onRemove"]),
          _createVNode(_component_a_button, {
            type: "primary",
            disabled: $setup.fileList.length === 0,
            loading: $setup.uploading,
            style: {"margin-top":"16px"},
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.handleUpload(0)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.uploading ? '正在加载' : '确认转账'), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]))
      : _createCommentVNode("", true),
    ($setup.activeKey === '2')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          ($setup.batchData.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_a_table, {
                  columns: $setup.batchColumns,
                  "data-source": $setup.batchData,
                  scroll: { x: 1500, y: 580 }
                }, {
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.dataIndex === 'Controls')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: ($event: any) => ($setup.OpenSuborderOpen(record)),
                            style: {"margin-bottom":"10px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("制单详情")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          (record.yidakuan === 0)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "primary",
                                danger: "",
                                onClick: ($event: any) => ($setup.api_cw_new_cancle_dkFun(record)),
                                disabled: ($setup.user.roule === 1 || $setup.user.roule === 0) ? false : true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("撤回制单")
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "data-source"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_modal, {
            open: $setup.suborderOpen,
            "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => (($setup.suborderOpen) = $event)),
            title: "制单详情",
            footer: null,
            width: "80%",
            onOk: _cache[9] || (_cache[9] = ($event: any) => ($setup.shenheOpen = !$setup.shenheOpen))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions, {
                bordered: "",
                size: "middle",
                style: {"padding":"50px"},
                title: "详情"
              }, _createSlots({
                default: _withCtx(() => [
                  _createVNode(_component_a_descriptions_item, { label: "批次号" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.piliangdata.ordersn), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_descriptions_item, { label: "审核状态" }, {
                    default: _withCtx(() => [
                      _createTextVNode("审核通过")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_descriptions_item, { label: "实际手续费" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.piliangdata.rate), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_descriptions_item, { label: "提交时间" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.piliangdata.time), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_descriptions_item, { label: "批次金额" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.piliangdata.all_money), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_descriptions_item, { label: "笔数" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.piliangdata.su_num), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_descriptions_item, { label: "操作员" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.piliangdata.payAccName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, [
                ($setup.piliangdata.yidakuan === 0)
                  ? {
                      name: "extra",
                      fn: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: $setup.showConfirm
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("立即打款")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  size: "middle",
                  style: {"width":"300px"},
                  onClick: $setup.OpenSuborderOpen
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查看子订单")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  size: "middle",
                  style: {"width":"300px"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.api_cw_export_dataFun($setup.piliangdata.id)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("打印")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  size: "middle",
                  style: {"width":"300px"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.suborderOpen = !$setup.suborderOpen))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("关闭")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_a_modal, {
                open: $setup.suborderOpens,
                "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => (($setup.suborderOpens) = $event)),
                title: "查看子订单",
                width: "80%",
                footer: null
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table, {
                    columns: $setup.suborderColumns,
                    "data-source": $setup.suborderData,
                    pagination: { pageSize: 1000 },
                    scroll: { y: 400 }
                  }, null, 8, ["columns", "data-source"])
                ]),
                _: 1
              }, 8, ["open"])
            ]),
            _: 1
          }, 8, ["open"])
        ]))
      : _createCommentVNode("", true),
    ($setup.activeKey === '1')
      ? (_openBlock(), _createBlock(_component_a_form, {
          key: 3,
          model: $setup.formState,
          rules: $setup.rules,
          name: "basic",
          "label-col": { span: 2 },
          "wrapper-col": { span: 16 },
          autocomplete: "off",
          onFinish: $setup.api_cw_document_preparationFun,
          onFinishFailed: $setup.onFinishFailed,
          layout: $setup.layout
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_divider, { orientation: "left" }, {
              default: _withCtx(() => [
                _createTextVNode("付款方信息")
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "本方账户名称",
              name: "payAccName",
              rules: [{ required: true, message: '本方账户名称不得为空' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formState.payAccName,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (($setup.formState.payAccName) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "本方账户",
              name: "payAccNo",
              rules: [{ required: true, message: '本方账户不得为空' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formState.payAccNo,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (($setup.formState.payAccNo) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "转账金额",
              name: "amount",
              rules: [{ required: true, message: '转账金额不得为空', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  size: "large",
                  placeholder: "请输入转账金额",
                  value: $setup.formState.amount,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (($setup.formState.amount) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, { orientation: "left" }, {
              default: _withCtx(() => [
                _createTextVNode("收款方信息")
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "收款账户名称",
              name: "recAccName",
              rules: [{ required: true, message: '收款账户名称不得为空' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formState.recAccName,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (($setup.formState.recAccName) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "收款账户",
              name: "recAccNo",
              rules: [{ required: true, message: '收款账户不得为空' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formState.recAccNo,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (($setup.formState.recAccNo) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            ($setup.formState.isSameBank === '2')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "行联号",
                  name: "recBankNo",
                  rules: [{ required: true, message: '行联号不得为空' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formState.recBankNo,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (($setup.formState.recBankNo) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.formState.isSameBank === '2')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  label: "银行名称",
                  name: "recBankName",
                  rules: [{ required: true, message: '银行名称不得为空' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formState.recBankName,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (($setup.formState.recBankName) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_divider, { orientation: "left" }, {
              default: _withCtx(() => [
                _createTextVNode("其他信息")
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "是否跨行",
              name: "isSameBank",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $setup.formState.isSameBank,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (($setup.formState.isSameBank) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("否")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("是")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "附言",
              name: "memo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formState.memo,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (($setup.formState.memo) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { "wrapper-col": { offset: 1, span: 1 } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit",
                  style: {"width":"100%"},
                  disabled: ($setup.user.roule === 0 || $setup.user.roule === 1) ? false : true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("制单")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "onFinish", "onFinishFailed", "layout"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      open: $setup.dakuanOpen,
      "onUpdate:open": _cache[19] || (_cache[19] = ($event: any) => (($setup.dakuanOpen) = $event)),
      title: "确认转账吗？确认后金额立即转出",
      okText: "确认",
      cancelText: "关闭",
      onOk: $setup.zhuanzhangFun
    }, null, 8, ["open", "onOk"]),
    _createVNode(_component_a_modal, {
      open: $setup.shenheOpen,
      "onUpdate:open": _cache[21] || (_cache[21] = ($event: any) => (($setup.shenheOpen) = $event)),
      title: "打款操作",
      okText: "确认",
      cancelText: "取消",
      onOk: $setup.shenheOpenFun
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              ref: "select",
              value: $setup.auditTypes,
              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (($setup.auditTypes) = $event)),
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "0" }, {
                  default: _withCtx(() => [
                    _createTextVNode("拒绝")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("同意")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "onOk"])
  ]))
}